import { borderRadius, color, padding } from '@evrekadev/evreka-ui-components'
import styled from 'styled-components'

export const MapFiltersStyled = styled.div<{ isRtl?: boolean }>`
  ${padding([8])}
  ${borderRadius(12)}
  background: ${color('white')};
  border: 1px solid ${color('grey200')};

  cursor: default;
  left: ${(props) => (props.isRtl ? '10px' : 'unset')};
  right: ${(props) => (props.isRtl ? 'unset' : '10px')};
  top: 10px;
  position: absolute;
  z-index: 501;
  height: calc(100% - 2rem);
  width: 30%;
  overflow: auto;
`
